import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import api from "../../utils/api";

const DeleteCellRenderer = (props) => {
  const APIBASE_URL = process.env.REACT_APP_APIBASE_URL;
  const [open, setOpen] = useState(false);
  const [warnopen, setWarnOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseOkay = () => {
    setOpen(false);
    setWarnOpen(false);
  };

  const deleteUsers = () => {
    const UniqueKeyVal = Array.isArray(props.value) ? props.value : [props.value];
    api
      .get(`${APIBASE_URL}/deleteGreenablUsers?UniqueKey=${UniqueKeyVal}`)
      .then((resp) => {
        if (resp.data[0] === 1) {
          setOpen(false);
          if (props.update) props.update(); // update grid
          if (props.onDeleteSuccess) props.onDeleteSuccess(); // show snackbar in parent
        } else {
          setWarnOpen(true);
        }
      });
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>
        <DeleteIcon />
      </Button>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Please confirm Delete action"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure to delete this User? This action can not be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={deleteUsers} color="primary" autoFocus>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={warnopen}
        onClose={handleCloseOkay}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title-1">
          {"Cannot Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            This user has existing dependencies. Deletion is not allowed.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseOkay} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteCellRenderer;